// extracted by mini-css-extract-plugin
module.exports = {"guarantee":"Guarantee_guarantee__YKnA_","icon":"Guarantee_icon__OC1tf","label":"Guarantee_label__vKl9y"};